import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken, clearAccessToken, getCurrentUser } from "../utils/auth/tokenStore";
import { roleRouteMap } from "../constants/options";

const MasterRouteGuard = ({ allowed, children }) => {

    const token = getAccessToken();
    const location = useLocation();

    // Not logged in → go to login
    if (!token) {
        return <Navigate to="/" replace />;
    }

    try {
        const user = getCurrentUser();
        const role = user?.role;

        // Invalid role → logout
        if (!role || !roleRouteMap[role]) {
            clearAccessToken();
            return <Navigate to="/" replace />;
        }

        const correctRoute = roleRouteMap[role];

        // Logged in BUT trying to access another role’s route
        if (!location.pathname.startsWith(correctRoute)) {
            return <Navigate to={correctRoute} replace />;
        }

        // Allowed roles check (extra safety)
        if (!allowed.includes(role)) {
            return <Navigate to={correctRoute} replace />;
        }

        // All good
        return children;

    } catch {
        clearAccessToken();
        return <Navigate to="/" replace />;
    }
};

export default MasterRouteGuard;